import React from 'react';

const CloudflareStreamPlayer = ({ uid, customerCode, title }) => {
  if (!uid || !customerCode) {
    return (
      <div className="bg-white/70 backdrop-blur-xl rounded-2xl border border-white/40 p-12 text-center">
        <p className="text-sm text-muted-foreground">This video is still processing. Check back shortly.</p>
      </div>
    );
  }

  return (
    <div className="aspect-video rounded-2xl overflow-hidden border border-white/40 shadow-sm bg-black">
      <iframe
        src={`https://customer-${customerCode}.cloudflarestream.com/${uid}/iframe`}
        title={title || 'Lesson video'}
        className="w-full h-full"
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
        allowFullScreen
      />
    </div>
  );
};

export default CloudflareStreamPlayer;